import * as React from 'react';
import styled from 'styled-components';

const Header: React.FunctionComponent = styled.h1`
    font-size: 25px;
    text-transform: uppercase;
`;

export default Header;